var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "250px",
    height: "250px",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-new-2020-seeklogo.com",
    transform: "translate(15.000000, 15.000000)",
    fill: "#0A66C2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.448207,187.453091 L154.851471,187.453091 L154.851471,136.40413 C154.851471,124.23102 154.634159,108.560476 137.897773,108.560476 C120.920307,108.560476 118.322755,121.823563 118.322755,135.517886 L118.322755,187.449696 L85.7260189,187.449696 L85.7260189,82.4723309 L117.018885,82.4723309 L117.018885,96.8186034 L117.456903,96.8186034 C123.837696,85.9084858 135.701994,79.3923088 148.332124,79.8611395 C181.370274,79.8611395 187.461789,101.592771 187.461789,129.864267 L187.448207,187.453091 Z M48.9460357,68.1226631 C38.4988558,68.1245377 30.028223,59.65676 30.0263471,49.2093516 C30.0244724,38.7619433 38.492065,30.2911252 48.9392449,30.2892493 C59.3864248,30.2873745 67.8570578,38.755152 67.8589339,49.2025603 C67.8598339,54.2195829 65.8677367,59.031479 62.3208803,62.5796865 C58.774024,66.127894 53.9629485,68.121762 48.9460357,68.1226631 M65.2444034,187.453091 L32.613713,187.453091 L32.613713,82.4723309 L65.2444034,82.4723309 L65.2444034,187.453091 Z M203.699038,0.0177648507 L16.2338534,0.0177648507 C7.37386159,-0.0822223426 0.108131335,7.01497534 0,15.8750652 L0,204.121933 C0.104429204,212.986292 7.36957475,220.090516 16.2338534,219.998766 L203.699038,219.998766 C212.580853,220.107604 219.874449,213.003789 219.997405,204.121933 L219.997405,15.8614829 C219.870756,6.98388995 212.576568,-0.112902073 203.699038,0.00136062401",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.7cf3e3c2e5a434fde86b947fa8059ecd.svg";
export { ForwardRef as ReactComponent };